import React, { useState, useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import { useSelector } from "react-redux";

//COMPONENTS
import BroswserCalendarView from "./files/browserCalendarView";
import MobileCalendarView from "./files/mobileCalendarView";

function PodRouter() {
    const [isLoaded, setIsLoaded] = useState(false);
    const GS_generalSettings = useSelector((state) => state.GS_generalSettings);

    useEffect(() => {
        setIsLoaded(true);
    }, []);

    return (
        <div>
            {isLoaded && (
                <div>
                    <Routes>
                        <Route path="/" element={GS_generalSettings.isMobile ? <MobileCalendarView /> : <BroswserCalendarView />} />
                        {/* <Route path="/" element={<MobileCalendarView />} /> */}
                    </Routes>
                </div>
            )}
        </div>
    );
}

export default PodRouter;
